/**
 * A chart gender as the pharmacies take it: "M", "F", or null when it's
 * neither (blank, "U", or a code nobody can read).
 *
 * The chart is not consistent: most rows say "F"/"M", but thousands say
 * "Female"/"Male" (and a few "Mujer"/"Hombre"). Reading only the letter
 * reported those patients as having no gender, which blocked Partell
 * prescriptions and left the order forms asking for one. Mirrors the server
 * (RmmIntegration::sex), so the form and the pharmacy submission agree.
 */
export function toGenderCode(value: string | null | undefined): 'M' | 'F' | null {
  const g = (value ?? '').trim().toLowerCase();
  if (['m', 'male', 'hombre', 'masculino'].includes(g)) return 'M';
  if (['f', 'female', 'mujer', 'femenino'].includes(g)) return 'F';
  return null;
}

/**
 * Whether the chart has no gender at all: blank, or a placeholder for
 * "unknown" ("U", "NS"). "Other" is an answer, not a gap — an order form may
 * fill a gap on the chart but never replace an answer.
 */
export function isBlankGender(value: string | null | undefined): boolean {
  return ['', 'u', 'ns', 'unknown', 'not specified'].includes((value ?? '').trim().toLowerCase());
}
